<script>
import CButton from '../components/CButton.vue'
import CTitleSmall from '../components/CTitleSmall.vue'
import CLogo from '../components/CLogo.vue'
import CMessage from '../components/CMessage.vue'

export default {
  name: 'CHomeOpen',

  components: {
    CButton,
    CTitleSmall,
    CLogo,
    CMessage
  },

  computed: {
    today: () => new Date(),
    publishAt () {
      return this.$store.state.publishedInfo.publishAt
    },
    unpublishAt () {
      return this.$store.state.publishedInfo.unpublishAt
    },
    readablePublishAt () {
      return this.$store.state.publishedInfo.readablePublishAt
    },
    readableUnpublishAt () {
      return this.$store.state.publishedInfo.readableUnpublishAt
    },
    isPausedByDate () {
      return this.$store.state.publishedInfo.isPausedByDate
    },
    live_intro_text () {
      return this.$store.state.textsInfo.introText
    }
  }
}
</script>

<template>
  <div>
    <c-logo />
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-if="live_intro_text"
      v-html="live_intro_text"
    />
    <!--eslint-enable-->
    <div v-else>
      <c-title-small>
        Projektförderung der Hamburgischen Kulturstiftung
      </c-title-small>
      <p class="mt-8 mb-8">
        Bitte lesen Sie vor dem Ausfüllen des Antragsformulars unbedingt die
        <a
          href="https://www.kulturstiftung-hh.de/antragstellung.html"
          target="_blank"
        >Hinweise zur Antragstellung</a>
        bei der Hamburgischen Kulturstiftung. Dort finden Sie wichtige Informationen
        zur Projektförderung sowie detaillierte Angaben, welche Unterlagen Sie für die
        Antragstellung bereithalten sollten.
      </p>
      <p>
        Bitte beachten Sie folgende Hinweise:
      </p>
      <br>
      <p>
        <ul>
          <li>
            Sie können Ihren Antrag nicht zwischenspeichern.
          </li>
          <li>
            Die Anträge werden in der Form bearbeitet, wie sie eingehen. Eine nachträgliche Korrektur oder Ergänzung ist nicht möglich.
          </li>
          <li>
            Daher empfehlen wir Ihnen, alle erforderlichen Informationen vorher vorzubereiten und für die Antragstellung bereitzuhalten.
          </li>
          <li>
            Dieses Antragsformular ist ausschließlich für die Projektförderung der Hamburgischen Kulturstiftung. Hier finden Sie Informationen zur Antragstellung für
            <a
              href="https://www.kulturstiftung-hh.de/was-wir-foerdern/art-connects.html"
              target="_blank"
            >ART CONNECTS</a>
            und
            <a
              href="https://www.kulturstiftung-hh.de/was-wir-foerdern/freiraeume.html"
              target="_blank"
            >FREIRÄUME!</a>.
          </li>
        </ul>
      </p>
      <br>
      <p>
        Das Antragsformular wird jeweils ca. sechs Wochen vor der Antragsfrist freigeschaltet. In der
        Zwischenzeit ist das Antragsformular in einer Testansicht verfügbar und das Einreichen von
        Anträgen nicht möglich.
      </p>
    </div>
    <br>
    <c-message
      v-if="publishAt && unpublishAt"
      type="info"
      class="mb-8"
    >
      <p class="mb-3">
        Das Formular kann noch bis {{ readableUnpublishAt }} Uhr ausgefüllt und abgeschickt werden. Danach ist eine Antragstellung erst zur nächsten Antragsfrist wieder möglich.
      </p>
    </c-message>
    <c-button
      tag="router-link"
      :to="{ name: 'request' }"
    >
      Antragsformular
    </c-button>
  </div>
</template>
